var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModerator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mod") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.781875%",
    y1: "-39.756875%",
    x2: "9.01675%",
    y2: "122.207187%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A4A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C70C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.2084375%",
    y1: "-14.8617187%",
    x2: "51.003125%",
    y2: "122.085%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-46.7321875%",
    y1: "146.7325%",
    x2: "100.000313%",
    y2: "-0.00159131875%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FF",
    offset: "99%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mod",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C31.1046,0 32,0.895431 32,2 L32,30 C32,31.1046 31.1046,32 30,32 L2,32 C0.895431,32 0,31.1046 0,30 L0,2 C0,0.895431 0.895431,0 2,0 L30,0 Z M16.2197,2.99316 C15.8292,2.60266 15.1962,2.60265 14.8057,2.99316 L8.36328,9.43555 C7.97294,9.82608 7.97284,10.4591 8.36328,10.8496 L10.0918,12.5781 C10.4823,12.9686 11.1153,12.9685 11.5059,12.5781 L11.585,12.499 L13.9414,14.8564 L3.57129,25.2275 C2.70357,26.0954 2.7035,27.5023 3.57129,28.3701 C4.43911,29.2376 5.84612,29.2377 6.71387,28.3701 L17.084,17.999 L19.4414,20.3564 L19.3633,20.4346 C18.9728,20.8251 18.9728,21.4581 19.3633,21.8486 L21.0918,23.5771 C21.4823,23.9676 22.1154,23.9676 22.5059,23.5771 L28.9482,17.1348 C29.3386,16.7443 29.3386,16.1112 28.9482,15.7207 L27.2197,13.9922 C26.8293,13.6017 26.1962,13.6018 25.8057,13.9922 L25.7266,14.0703 L23.3701,11.7139 C24.2377,10.8461 24.2376,9.4391 23.3701,8.57129 C22.5023,7.7035 21.0954,7.70357 20.2275,8.57129 L17.8701,6.21387 L17.9482,6.13574 C18.3388,5.74522 18.3388,5.11221 17.9482,4.72168 L16.2197,2.99316 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C31.1046,0 32,0.895431 32,2 L32,30 C32,31.1046 31.1046,32 30,32 L2,32 C0.895431,32 0,31.1046 0,30 L0,2 C0,0.895431 0.895431,0 2,0 L30,0 Z M16.2197,2.99316 C15.8292,2.60266 15.1962,2.60265 14.8057,2.99316 L8.36328,9.43555 C7.97294,9.82608 7.97284,10.4591 8.36328,10.8496 L10.0918,12.5781 C10.4823,12.9686 11.1153,12.9685 11.5059,12.5781 L11.585,12.499 L13.9414,14.8564 L3.57129,25.2275 C2.70357,26.0954 2.7035,27.5023 3.57129,28.3701 C4.43911,29.2376 5.84612,29.2377 6.71387,28.3701 L17.084,17.999 L19.4414,20.3564 L19.3633,20.4346 C18.9728,20.8251 18.9728,21.4581 19.3633,21.8486 L21.0918,23.5771 C21.4823,23.9676 22.1154,23.9676 22.5059,23.5771 L28.9482,17.1348 C29.3386,16.7443 29.3386,16.1112 28.9482,15.7207 L27.2197,13.9922 C26.8293,13.6017 26.1962,13.6018 25.8057,13.9922 L25.7266,14.0703 L23.3701,11.7139 C24.2377,10.8461 24.2376,9.4391 23.3701,8.57129 C22.5023,7.7035 21.0954,7.70357 20.2275,8.57129 L17.8701,6.21387 L17.9482,6.13574 C18.3388,5.74522 18.3388,5.11221 17.9482,4.72168 L16.2197,2.99316 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C31.1046,0 32,0.895431 32,2 L32,30 C32,31.1046 31.1046,32 30,32 L2,32 C0.895431,32 0,31.1046 0,30 L0,2 C0,0.895431 0.895431,0 2,0 L30,0 Z M16.2197,2.99316 C15.8292,2.60266 15.1962,2.60265 14.8057,2.99316 L8.36328,9.43555 C7.97294,9.82608 7.97284,10.4591 8.36328,10.8496 L10.0918,12.5781 C10.4823,12.9686 11.1153,12.9685 11.5059,12.5781 L11.585,12.499 L13.9414,14.8564 L3.57129,25.2275 C2.70357,26.0954 2.7035,27.5023 3.57129,28.3701 C4.43911,29.2376 5.84612,29.2377 6.71387,28.3701 L17.084,17.999 L19.4414,20.3564 L19.3633,20.4346 C18.9728,20.8251 18.9728,21.4581 19.3633,21.8486 L21.0918,23.5771 C21.4823,23.9676 22.1154,23.9676 22.5059,23.5771 L28.9482,17.1348 C29.3386,16.7443 29.3386,16.1112 28.9482,15.7207 L27.2197,13.9922 C26.8293,13.6017 26.1962,13.6018 25.8057,13.9922 L25.7266,14.0703 L23.3701,11.7139 C24.2377,10.8461 24.2376,9.4391 23.3701,8.57129 C22.5023,7.7035 21.0954,7.70357 20.2275,8.57129 L17.8701,6.21387 L17.9482,6.13574 C18.3388,5.74522 18.3388,5.11221 17.9482,4.72168 L16.2197,2.99316 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerator);
export default __webpack_public_path__ + "static/media/moderator.61cc62fa828601668b5bd97a0e6ae84e.svg";
export { ForwardRef as ReactComponent };